import {
  BookOpen,
  BriefcaseBusiness,
  Camera,
  CarFront,
  ChefHat,
  Clapperboard,
  Coffee,
  Cpu,
  Dumbbell,
  Gamepad2,
  Heart,
  HeartPulse,
  House,
  Laugh,
  Megaphone,
  Music2,
  Newspaper,
  PawPrint,
  PenTool,
  Plane,
  Rocket,
  Shapes,
  Shirt,
  Sparkles,
  Sprout,
  Trophy,
  Utensils,
  Video,
  WalletCards,
  type LucideIcon,
} from "lucide-react";

export const CORE_CATEGORY_ICONS = {
  tecnologia: Cpu,
  games: Gamepad2,
  educacao: BookOpen,
  humor: Laugh,
  financas: WalletCards,
  empreendedorismo: Rocket,
  lifestyle: Coffee,
  moda: Shirt,
  beleza: Sparkles,
  fitness: Dumbbell,
  saude: HeartPulse,
  alimentacao: Utensils,
  viagens: Plane,
  musica: Music2,
  "cinema-e-series": Clapperboard,
  esportes: Trophy,
  automoveis: CarFront,
  fotografia: Camera,
  "desenvolvimento-pessoal": Sprout,
  noticias: Newspaper,
  marketing: Megaphone,
  negocios: BriefcaseBusiness,
  pets: PawPrint,
  "casa-e-decoracao": House,
  outros: Shapes,
} as const satisfies Record<string, LucideIcon>;

const LEGACY_CATEGORY_ICONS = {
  design: PenTool,
  video: Video,
  gastronomia: ChefHat,
  "bem-estar": Heart,
} as const satisfies Record<string, LucideIcon>;

export function getCategoryIcon(slug: string): LucideIcon {
  const normalizedSlug = slug.trim().toLowerCase();
  return CORE_CATEGORY_ICONS[normalizedSlug as keyof typeof CORE_CATEGORY_ICONS]
    ?? LEGACY_CATEGORY_ICONS[normalizedSlug as keyof typeof LEGACY_CATEGORY_ICONS]
    ?? Shapes;
}
